import { cx } from './cx';

/**
 * 36×20, brand when on and `surface-3` when off.
 *
 * A `role="switch"` button rather than a checkbox with a label drawn over it: the state is
 * announced as on or off rather than as checked, and there is no hidden input to keep in
 * step with the visible one.
 */
export function Switch({
  checked,
  onChange,
  disabled,
  label,
  className,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** What the switch is for, for anyone who cannot see the row it sits on. */
  label?: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cx(
        'relative w-9 h-5 shrink-0 rounded-full border-0 disabled:cursor-not-allowed disabled:opacity-60',
        checked ? 'bg-brand' : 'bg-surface-3',
        className,
      )}
    >
      <span
        className={cx(
          'absolute top-0.5 w-4 h-4 rounded-full',
          checked ? 'right-0.5 bg-on-brand' : 'left-0.5 bg-ink-3',
        )}
      />
    </button>
  );
}
